/* eslint-disable jsx-a11y/anchor-is-valid */
import URL from "constant/url";
import { useNavigate } from "react-router-dom";

export default function S5ProxyCategory() {
  const navigate = useNavigate();
  return (
    <li className="has-submenu">
      <a href="">S5 Proxy</a>
      <div className="submenu-wrapper menu-list theme-megamenu">
        <div className="row">
          <div className="col-md-6">
            <div className="megamenu-item">
              <a
                href=""
                onClick={() => {
                  navigate(URL.List922S5Proxy);
                }}
              >
                <div className="menu-list-wrapper d-flex align-items-center">
                  <img
                    style={{
                      alignSelf: "center",
                    }}
                    src="assets/partner/922.png"
                    alt="server"
                    width={65}
                    height={20}
                  ></img>
                  <div className="menu-list-content-right ms-3">
                    <h6>922 Proxy</h6>
                  </div>
                </div>
              </a>
            </div>
            <div className="megamenu-item">
              <a
                href=""
                onClick={() => {
                  navigate(URL.ListPIAS5Proxy);
                }}
              >
                <div className="menu-list-wrapper d-flex align-items-center">
                  <img
                    style={{
                      alignSelf: "center",
                    }}
                    src="assets/partner/pia.png"
                    alt="server"
                    width={65}
                    height={12}
                  ></img>
                  <div className="menu-list-content-right ms-3">
                    <h6>PIA Proxy</h6>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}
